import { render, staticRenderFns } from "./PresetsSearches.vue?vue&type=template&id=01d0c8f2&scoped=true"
import script from "./PresetsSearches.vue?vue&type=script&lang=js"
export * from "./PresetsSearches.vue?vue&type=script&lang=js"
import style0 from "./PresetsSearches.vue?vue&type=style&index=0&id=01d0c8f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d0c8f2",
  null
  
)

export default component.exports